import { NativeDateAdapter } from '@angular/material/core';
import { formatDate } from '@angular/common';
import { Inject, Injector, Injectable } from '@angular/core';
import { UserService } from 'merlin-library';
import { ApiService } from 'merlin-library';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpHandler } from '@angular/common/http';
import { Platform } from '@angular/cdk/platform';
import { DateTimeService } from './date-time.service';

@Injectable({ providedIn: 'root' })
export class CustomDateAdapter extends NativeDateAdapter {
    dateFormatString = 'MM-dd-yyyy';

    constructor(private dateTimeService: DateTimeService){
        super('en-US');
    }

    getFirstDayOfWeek(): number {
        return 1;
     }

    format(date: Date, displayFormat: Object): string {
        if (displayFormat === 'input') {
            return formatDate(date, this.dateTimeService.getFormat(), this.locale);;
        } else {
            return date.toDateString();
        }
    }
  }
